<template>
    <div class="quotes">
      <UserHeaderMenu/>
        <div class="container mt-3">
          <h4 class="pb-2"><b>Árajánlatok</b><b-button class="float-right" :style="{ 'background-color': companyData.color, 'border' : companyData.color  }" v-b-toggle.sidebar-no-header>Találatok szűkítése</b-button></h4>
          <div class="overflow-auto">
              <b-table
              id="my-table"
              :items="items"
              :per-page="perPage"
              :current-page="currentPage"
              small
              @row-clicked="expandAdditionalInfo"
              >
              </b-table>
          </div>
          <b-pagination
              :style="{ 'color': companyData.color+' !important'}"
              v-model="currentPage"
              pills
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              class="justify-content-center">
              <template v-slot:page="{ page, active }">
                <b :style="{ 'color': companyData.color+' !important'}" class="currentpage" v-if="active">{{ page }}</b>
                <i :style="{ 'color': '#b7b7b7 !important'}" v-else>{{ page }}</i>
              </template>
              </b-pagination>
        </div>
    <b-sidebar id="sidebar-no-header" aria-labelledby="sidebar-no-header-title" no-header shadow>
      <template v-slot:default="{ hide }">
        <div class="p-3">
          <h4 id="sidebar-no-header-title">Keresések szűkítése <b-icon :style="{'color': companyData.color}" class="close-icon" icon="x-circle" scale="2" block @click="hide"></b-icon></h4>
          <p>
            Lehetőséged van árajánataid szűkíteni könnyebb keresés érdekében.
          </p>
          <nav class="mb-3">
            <b-nav vertical>
              <b-form-select v-model="selectedQuotesType" @change="loadTable" :options="quotesTypes" placeholder="Ajánlatkérés típusa"></b-form-select>
              <b-form-input class="mt-2" v-model="QuotesStatus" @keyup="loadTable" placeholder="Árajánlat státusza"></b-form-input>
              <b-form-input class="mt-2" v-model="QuotesClientName" @keyup="loadTable" placeholder="Ügyfél cégnév"></b-form-input>
              <b-form-input class="mt-2" v-model="QuotesClientContactName" @keyup="loadTable" placeholder="Ügyfél kapcsolattartó"></b-form-input>
              <b-form-input class="mt-2" v-model="QuotesNumber" @keyup="loadTable" placeholder="Árajánlatszám"></b-form-input>
              <b-form-datepicker v-model="QuotesCreateDate" @keyup="loadTable" placeholder="Árajánlat készítés ideje" class="mt-2"></b-form-datepicker>
              <b-form-input class="mt-2" v-model="QuotesCreaterName" @keyup="loadTable" placeholder="Árajánlat készítő neve"></b-form-input>
              <b-form-input class="mt-2" v-model="QuotesCreaterPhoneNumber" @keyup="loadTable" placeholder="Árajánlat készítő telefonszáma"></b-form-input>
              <b-form-select class="mt-2" v-model="megrendelve" @change="loadTable" :options="quotesRendelesTipusok" placeholder="Ajánlatkérés típusa"></b-form-select>
            </b-nav>
          </nav>
          <b-button :style="{ 'background-color': companyData.color, 'border' : companyData.color  }" variant="primary" block @click="hide">Bezár</b-button>
        </div>
      </template>
    </b-sidebar>
        <SettingsModal/>
    </div>
</template>
<script>
import router from '../router'
import axios from 'axios'
import SettingsModal from '../components/SettingsModal.vue'
import UserHeaderMenu from '../components/UserHeaderMenu.vue'

export default {
  components: {
    SettingsModal,
    UserHeaderMenu
  },
  name: 'quotes',
  mounted () {
    this.loadTable()
    this.loadTypes()
    this.getCompanyData()
  },
  data () {
    return {
      perPage: 15,
      currentPage: 1,
      selectedQuotesType: '',
      QuotesStatus: '',
      QuotesClientName: '',
      QuotesClientContactName: '',
      QuotesNumber: '',
      QuotesCreateDate: '',
      QuotesCreaterName: '',
      megrendelve: '',
      QuotesCreaterPhoneNumber: '',
      quotesTypes: [
      ],
      quotesRendelesTipusok: [
		{text:'Megrendelés állapota', value:''},
		{text:'Kiküldött', value:0},
    {text:'Elfogadott', value:1},
    {text:'Megtekintett', value:2}
      ],
      items: [
      ],
      companyData: [
      ]
    }
  },
  computed: {
    rows () {
      return this.items.length
    }
  },
  methods: {
    getCompanyData () {
      const params = new URLSearchParams()
      params.append('getCompanyData', true)
      params.append('user_id', this.$session.get('id'))
      axios({
        method: 'post',
        url: process.env.VUE_APP_LOGIN_API,
        data: params
      }).then((response) => {
        this.companyData = response.data[0]
      })
    },
    expandAdditionalInfo (row) {
      const params = new URLSearchParams()
      params.append('setQuotesWatched', true)
      params.append('user_id', this.$session.get('id'))
      params.append('quotes_id', row.sorszam)
      axios({
        method: 'post',
        url: process.env.VUE_APP_QUOTES_API,
        data: params
      }).then(() => {
        router.push({ path: `/quotesinfo/${row.sorszam}` })
      })
    },
    loadTypes () {
      let params = new URLSearchParams()
      params = new URLSearchParams()
      params.append('getAllQuotesTypes', true)
      params.append('user_id', this.$session.get('id'))
      axios({
        method: 'post',
        url: process.env.VUE_APP_QUOTES_API,
        data: params
      }).then((response) => {
        this.quotesTypes = response.data
      })
    },
    loadTable () {
      const params = new URLSearchParams()
      params.append('getAllQuotes', true)
      params.append('QuotesStatus', this.QuotesStatus)
      params.append('QuotesClientName', this.QuotesClientName)
      params.append('QuotesClientContactName', this.QuotesClientContactName)
      params.append('QuotesNumber', this.QuotesNumber)
      params.append('QuotesCreateDate', this.QuotesCreateDate)
      params.append('QuotesCreaterName', this.QuotesCreaterName)
      params.append('QuotesCreaterPhoneNumber', this.QuotesCreaterPhoneNumber)
      params.append('megrendelve', this.megrendelve)
      params.append('selectedQuotesType', this.selectedQuotesType)
      params.append('user_id', this.$session.get('id'))
      axios({
        method: 'post',
        url: process.env.VUE_APP_QUOTES_API,
        data: params
      }).then((response) => {
        this.items = response.data
      })
    }
  }
}
</script>
<style>

td:hover{
  cursor: pointer;
}
.page-item.active .page-link{
  background-color: white !important;
  border: 1px solid #dee2e6;
}
.page-link{
  color:#dee2e6 !important;
}
.close-icon{
  font-size: 12px;
  float:right;
  cursor: pointer;
}
</style>
